import { Instagram, Mail } from "lucide-react";
import { Logo } from "./Logo";
import { HOST } from "../data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#201B17] text-[#FBF8F3]">
    <div className="mx-auto flex max-w-7xl flex-col gap-12 px-6 py-16 md:flex-row md:items-end md:justify-between lg:px-10">
      <div>
        <Logo dark />
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#FBF8F3]/60">
          A husband-and-wife collection of sky-high apartments, personally
          hosted in the heart of Melbourne.
        </p>
      </div>
      <nav className="flex flex-col gap-3" aria-label="Footer">
        {[
          { label: "About", href: "#about" },
          { label: "Properties", href: "#properties" },
          { label: "Reviews", href: "#reviews" },
          { label: "Airbnb profile", href: HOST.airbnbProfile, external: true },
        ].map((link) => (
          <a
            key={link.label}
            href={link.href}
            {...(link.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
            className="link-line w-fit font-mono-accent text-[11px] uppercase tracking-[0.22em] text-[#FBF8F3]/70 transition-colors duration-300 hover:text-[#E3A387]"
          >
            {link.label}
          </a>
        ))}
      </nav>
      <div className="flex gap-3">
        <a
          href={HOST.airbnbProfile}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram-link"
          aria-label="Instagram"
          className="flex h-11 w-11 items-center justify-center rounded-full border border-[#FBF8F3]/20 text-[#FBF8F3]/70 transition-colors duration-300 hover:border-[#C4623C] hover:bg-[#C4623C] hover:text-[#FBF8F3]"
        >
          <Instagram className="h-4 w-4" />
        </a>
        <a
          href={HOST.airbnbProfile}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-mail-link"
          aria-label="Contact via Airbnb"
          className="flex h-11 w-11 items-center justify-center rounded-full border border-[#FBF8F3]/20 text-[#FBF8F3]/70 transition-colors duration-300 hover:border-[#C4623C] hover:bg-[#C4623C] hover:text-[#FBF8F3]"
        >
          <Mail className="h-4 w-4" />
        </a>
      </div>
    </div>
    <div className="border-t border-[#FBF8F3]/10">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-6 font-mono-accent text-[10px] uppercase tracking-[0.18em] text-[#FBF8F3]/40 md:flex-row md:items-center md:justify-between lg:px-10">
        <p>© 2026 ALMAH Stays · {HOST.location}</p>
        <p>Hosted with uncommon care</p>
      </div>
    </div>
  </footer>
);
